import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue";
var _hoisted_1 = {
  class: "dict-content"
};
var _hoisted_2 = {
  key: 0
};
var _hoisted_3 = ["onClick"];
var _hoisted_4 = {
  class: "title"
};
var _hoisted_5 = {
  class: "code"
};
var _hoisted_6 = {
  class: "action"
};
var _hoisted_7 = ["onClick"];
var _hoisted_8 = ["onClick"];
import { DICTIONARY_STATUS } from '@/constant/system/code';
import { renderEditForm } from './dictEdit';
import { deleteBox, toast } from '@/utils/message';
import { remove } from '@/api/system/dictionary';

import { ref, toRefs, onMounted, watch } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'DictionaryItem',
  props: {
    items: {}
  },
  emits: ['select', 'update', 'search', 'delete'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var prop = __props;
    var emit = __emit;
    var dataEditRef = ref();
    var _toRefs = toRefs(prop),
      items = _toRefs.items;
    var current = ref(-1);
    var dataEdit;
    onMounted(function () {
      dataEdit = renderEditForm(dataEditRef.value);
      dataEdit.onSaveSuccess = function () {
        emit('update');
      };
    });
    watch(function () {
      return prop.items;
    }, function (newVal) {
      if (newVal.length > 0) {
        if (current.value) {
          var item = newVal.find(function (item) {
            return item.id === current.value;
          });
          currentChange(item || newVal[0]);
        } else {
          currentChange(newVal[0]);
        }
      }
    }, {
      immediate: true
    });
    function currentChange(item) {
      current.value = item.id;
      emit('select', item);
    }
    function itemEdit(item) {
      dataEdit.open(item.id);
    }
    function itemDelete(item) {
      deleteBox().then(function () {
        return remove([item.id]);
      }).then(function () {
        toast.success('删除成功');
        emit('delete');
      });
    }
    return function (_ctx, _cache) {
      var _component_el_empty = _resolveComponent("el-empty");
      var _component_Edit = _resolveComponent("Edit");
      var _component_el_icon = _resolveComponent("el-icon");
      var _component_Delete = _resolveComponent("Delete");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_unref(items).length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_el_empty, {
        description: "列表为空"
      })])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items), function (item, index) {
        return _openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["dict-item", item.id === _unref(current) ? 'active' : '']),
          key: index,
          onClick: function onClick($event) {
            return currentChange(item);
          }
        }, [_createElementVNode("div", _hoisted_4, [_createElementVNode("span", {
          class: _normalizeClass(item.status === _unref(DICTIONARY_STATUS).ENABLED.CODE ? 'status-success' : 'status-error')
        }, null, 2), _createTextVNode(" " + _toDisplayString(item.dictionaryName), 1)]), _createElementVNode("span", _hoisted_5, _toDisplayString(item.dictionaryCode), 1), _createElementVNode("span", _hoisted_6, [_createElementVNode("div", {
          onClick: _withModifiers(function ($event) {
            return itemEdit(item);
          }, ["stop"])
        }, [_createVNode(_component_el_icon, null, {
          default: _withCtx(function () {
            return [_createVNode(_component_Edit)];
          }),
          _: 1
        })], 8, _hoisted_7), _createElementVNode("div", {
          onClick: _withModifiers(function ($event) {
            return itemDelete(item);
          }, ["stop"])
        }, [_createVNode(_component_el_icon, null, {
          default: _withCtx(function () {
            return [_createVNode(_component_Delete)];
          }),
          _: 1
        })], 8, _hoisted_8)])], 10, _hoisted_3);
      }), 128)), _createElementVNode("div", {
        ref_key: "dataEditRef",
        ref: dataEditRef
      }, null, 512)]);
    };
  }
});